import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { format } from 'date-fns';
import { useAppDispatch, useAppSelector } from '@activitySelector/store/hooks';
import { getPreviousLevelSelected, goBackOneLevel, selectOption, } from '@activitySelector/store/reducers/activities';
import Option from './components/Option';
import Tile from './components/Tile';
import Styles from './styles';
function ActivityList(props) {
    const { options, level, label, showBack, presentation, } = props;
    const dispatch = useAppDispatch();
    const prevLevel = useAppSelector(getPreviousLevelSelected(`level${level - 1}`));
    if (!options)
        return null;
    const onClick = async (option) => {
        const { Url, Value } = option;
        if (Url) {
            window.location.assign(Url);
            return;
        }
        if (Value.indexOf('~') >= 0) {
            const today = format(new Date(), 'yyyy-MM-dd');
            const ID = Value.replace('~', '');
            window.location.assign(`/booking/availability/?ProductId=${ID}&VisitDate=${today}&Visitors0=1`);
            return;
        }
        dispatch(selectOption(option, level));
    };
    const moveBack = () => {
        dispatch(goBackOneLevel(level));
    };
    const renderLabel = () => {
        if (showBack) {
            return (_jsxs(Styles.Label, { onClick: moveBack, isTitle: false, children: [_jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--chevron-new" }) }), _jsx("span", { children: prevLevel ? prevLevel.Text : label })] }));
        }
        if (label) {
            return _jsx(Styles.Label, { as: "span", isTitle: true, children: label });
        }
        return null;
    };
    const renderList = () => {
        const filteredOptions = options.filter((option) => option.Text && option.Text.length);
        if (presentation === 'tiles') {
            return (_jsx(Styles.Grid, { children: filteredOptions.map((option) => (_jsx(Styles.GridItem, { children: _jsx(Tile, { option: option, onClicked: onClick }) }))) }));
        }
        return (_jsx(Styles.List, { children: filteredOptions.map((option) => (_jsx(Styles.ListItem, { children: _jsx(Option, { option: option, onClicked: onClick }) }))) }));
    };
    return (_jsxs(Styles.Element, { children: [renderLabel(), renderList()] }));
}
ActivityList.defaultProps = {
    showBack: false,
    label: null,
};
export default ActivityList;
